var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-success mr-1",staticStyle:{"padding":".25rem .75rem"},attrs:{"href":_vm.url}},[_c('fa',{staticClass:"fa fa-2x",staticStyle:{"font-size":"1.5em"},attrs:{"icon":"file-code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }